import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import { BaseGridDirective } from '../base-grid.directive';
import { QPointNumberFormatPipe } from '@qpoint/i18n';
import { TranslateModule } from '@ngx-translate/core';
import { QPointLoadingSpinnerComponent } from '@qpoint/loading';
import { CheckBoxDirective } from '@progress/kendo-angular-inputs';
import { GridComponent, GroupBindingDirective, SelectionDirective, ExpandDetailsDirective, CustomMessagesComponent, CheckboxColumnComponent, HeaderTemplateDirective, SelectAllCheckboxDirective, CellTemplateDirective, FocusableDirective, SelectionCheckboxDirective, ExcelComponent, DetailTemplateDirective, NoRecordsTemplateDirective, ToolbarTemplateDirective, ColumnChooserComponent } from '@progress/kendo-angular-grid';
import { NgClass, NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'qpoint-grid-virtual-group',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['../grid.component.scss'],
    templateUrl: './grid-virtual-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, GridComponent, GroupBindingDirective, SelectionDirective, ExpandDetailsDirective, CustomMessagesComponent, CheckboxColumnComponent, HeaderTemplateDirective, NgIf, CheckBoxDirective, SelectAllCheckboxDirective, CellTemplateDirective, FocusableDirective, SelectionCheckboxDirective, ExcelComponent, DetailTemplateDirective, NgTemplateOutlet, NoRecordsTemplateDirective, ToolbarTemplateDirective, ColumnChooserComponent, QPointLoadingSpinnerComponent, TranslateModule, QPointNumberFormatPipe]
})
export class QPointGridVirtualGroupComponent extends BaseGridDirective {
}
